import { IPoint, pointDistance, subPoints } from "../../helpers/Geometry";
import { SongView } from "../SongView";
import { BaseViewTool } from "./BaseViewTool";

const SEEK_TOOL = "SEEK";

export class SeekTool extends BaseViewTool {

    protected _downHandler: (ev: PointerEvent) => void;
    protected _upHandler: (ev: PointerEvent) => void;
    protected _startPos: IPoint;
    protected _startPointer: number;

    constructor() {

        super()

        this._downHandler = ev => {

            if (ev.button != 0 || this._isStarted)
                return;

            this._startPointer = ev.pointerId;

            this._isStarted = true;

            this._startPos = this.getViewPoint(ev);
                  
            this._host.container.addEventListener("pointerup", this._upHandler);
        };

        this._upHandler = ev => {

            if (this._startPointer != ev.pointerId)
                return;

            this._isStarted = false;

            const curPos = this.getViewPoint(ev);

            if (pointDistance(this._startPos, curPos) < 3)
                (this._host as SongView).position = this._host.viewToWorld(curPos).x;

            this._host.container.removeEventListener("pointerup", this._upHandler);
        }
    }

    override activate() {

        super.activate();
        this._host.container.addEventListener("pointerdown", this._downHandler);
    }

    override deactivate() {
        this._host.container.removeEventListener("pointerdown", this._downHandler);
        super.deactivate();
    }


    readonly name = SEEK_TOOL;
}